import React, { useState, useEffect } from 'react';
import axios from '../../axiosConfig';
import { useParams, useNavigate } from 'react-router-dom'; // Importa useNavigate
import { Card, ListGroup, Button } from 'react-bootstrap';
import { useLoading } from '../../components/LoadingContext'; 



const ShowMorePartIniciativa = ({ onReload }) => {
  const { id } = useParams();
  const [data, setData] = useState({});
  const navigate = useNavigate(); // Inicializa useNavigate
  const { setLoading } = useLoading(); // Usar el contexto de carga

  useEffect(() => {
    const fetchData = async () => {
        setLoading(true); // Inicia la animación de carga
        try {
            let relationsArray = [ 'genero', 'nivelInstruccion'];
            const relations = relationsArray.join(',');
            const token = localStorage.getItem('token');

            const response = await axios.get(`/part-iniciativas/${id}?with=${relations}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            let data = response.data;

            // Calcular la edad usando la fecha de nacimiento y la fecha actual
            if (data.fecha_nacimiento) {
                const birthDate = new Date(data.fecha_nacimiento);
                const today = new Date();
                let age = today.getFullYear() - birthDate.getFullYear();
                const monthDiff = today.getMonth() - birthDate.getMonth();

                // Ajustar edad si el cumpleaños aún no ha ocurrido este año
                if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
                    age--;
                }

                // Agregar la edad al objeto de datos
                data.edad = age;
            }

            setData(data);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false); // Detiene la animación de carga
        }
    };

    fetchData();
}, [id, setLoading]);


  return (
    <div className="container my-5"> {/* Añadido margen superior */}
      <div className="row justify-content-center"> {/* Centra el contenido */}
        <div className="col-lg-9 col-md-8"> {/* Ajusta el tamaño de la tarjeta */}
          <Card className="p-4 shadow"> {/* Añadido padding y sombra */}
            <h1 className="mb-4 text-center">Detalles del Participante V-{data.cedula_identidad}</h1> {/* Centrado el título */}
            <ListGroup variant="flush">
              <ListGroup.Item>Cedula de identidad: {data.cedula_identidad}</ListGroup.Item>
              <ListGroup.Item>Nombres: {data.nombres}</ListGroup.Item>
              <ListGroup.Item>Apellidos: {data.apellidos}</ListGroup.Item>
              <ListGroup.Item>Fecha de Nacimiento {data.fecha_nacimiento}</ListGroup.Item>
              <ListGroup.Item>Edad: {data.edad}</ListGroup.Item>
              <ListGroup.Item>Género: {data.genero?.descripcion}</ListGroup.Item>
              <ListGroup.Item>Nivel de Instrucción: {data.nivel_instruccion?.descripcion}</ListGroup.Item>
              <ListGroup.Item>Email: {data.email}</ListGroup.Item>
              <ListGroup.Item>Tlf de Casa: {data.tlf_casa}</ListGroup.Item>
              



            </ListGroup>
  
            <div className="text-center mt-4">
            <Button
                variant="secondary"
                onClick={() => navigate(-1)}  // Esto navega a la última página
                >
                Volver
                </Button>
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
  
    };

export default ShowMorePartIniciativa;
 